interface PlanBadgeProps {
  plan: string;
}

const planColors = {
  basic: {
    bg: 'bg-blue-500/20',
    text: 'text-blue-400'
  },
  premium: {
    bg: 'bg-purple-500/20',
    text: 'text-purple-400'
  },
  enterprise: {
    bg: 'bg-yellow-500/20',
    text: 'text-yellow-400'
  }
};

export function PlanBadge({ plan }: PlanBadgeProps) {
  const colors = planColors[plan as keyof typeof planColors] || planColors.basic;
  
  return (
    <span className={`px-2 py-1 rounded-lg text-xs font-medium ${colors.bg} ${colors.text}`}>
      {plan.charAt(0).toUpperCase() + plan.slice(1)}
    </span>
  );
}
